var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(!_vm.pageLoading && _vm.$vuetify.breakpoint.smAndUp)?_c('navbar'):_vm._e(),_c('v-main',[_c('service-banner'),_c('terms-and-conditions'),(_vm.pageLoading)?_c('page-loading'):_c('router-view')],1),(!_vm.pageLoading && _vm.$vuetify.breakpoint.xs)?_c('bottom-nav'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }